import type { TDuration } from '@apps/Anim/definitions'

export enum ENativeLoadingEvent {
  Show = 'Loading:Show',
  Hide = 'Loading:Hide'
}

export interface ILoadingAnimProps {
  readonly duration: TDuration
}

export { DURATION_TYPES } from '@apps/Anim/definitions'
